import React from 'react';
import { useRefresh, useTranslate, useRecordContext, useUpdate, useDataProvider } from 'react-admin';
import MUIButton from '@mui/material/Button';
import { useSnackbar } from 'notistack';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import { UPDATE } from 'ra-core';

function EnableDisableButton() {
    const { enqueueSnackbar } = useSnackbar();
    const translate = useTranslate();
    const record = useRecordContext();
    const [update, { isLoading }] = useUpdate();
    const refresh = useRefresh();
    const dataProvider = useDataProvider();

    const handleClick = async () => {
        if (!record) return null;

        let updateData = {
                flag_disattivazione: record.flag_disattivazione ? false : true,
                disattivato_il: new Date(),
                disattivato_da: localStorage.getItem('username')
        };

        update('magmois', { id: record.id, data: updateData, previousData: record }, {
            onSuccess: (data) => {
                refresh();
                enqueueSnackbar(translate('tim.magmoi_enabledisable.updated'), {
                    variant: 'success',
                    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                    autoHideDuration: 3000,
                });

                if (record.flag_disattivazione) {
                    var user = localStorage.getItem('username');
                    dataProvider(UPDATE, 'sendtosap', { id: record.id, "username": user, "body": record.cod_terr_sap });
                }
            },
            onError: (error) => {
                console.log(error.message);
                enqueueSnackbar(translate('tim.magmoi_enabledisable.error'), {
                    variant: 'error',
                    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                    autoHideDuration: 3000,
                });
            },
        });
    };

    return (
        <MUIButton onClick={handleClick} color={record.flag_disattivazione ? "primary" : "red"} disabled={isLoading}>
            {record.flag_disattivazione ? <LockOpenIcon /> : <LockIcon />}
            &nbsp;
            {record.flag_disattivazione ? translate('tim.magmoi_enabledisable.button_label_enable') : translate('tim.magmoi_enabledisable.button_label_disable')}
        </MUIButton>
    );
}

export default EnableDisableButton;